import { TbArrowLeft, TbCheck } from "react-icons/tb";
import { Button } from "@/components/Button";
import { TextField } from "@/components/form/TextField";
import { useSubmit } from "@/submit/SubmitProvider";
import styles from "../PageSubmit.module.css";

export function AddressVerify() {
  const { form, back, next, canProceed } = useSubmit();
  const { control } = form;

  return (
    <div>
      <h2 className={styles.heading}>Verify address</h2>
      <TextField control={control} name="address.line1" label="Adress line 1" />
      <TextField control={control} name="address.line2" label="Adress line 2" />
      <TextField control={control} name="address.city" label="City" />
      <TextField control={control} name="address.state" label="State" />
      <TextField control={control} name="address.zipCode" label="ZIP code" />

      <div className={styles.actions}>
        <Button icon={TbArrowLeft} onClick={back} variant="ghost">
          Back
        </Button>
        <Button icon={TbCheck} onClick={next} disabled={!canProceed}>
          Confirm
        </Button>
      </div>
    </div>
  );
}
